import { useEffect, useState } from 'react'

import { Container, Theme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import useMediaQuery from '@mui/material/useMediaQuery'

import Seed from '@/components/atoms/Seed'
import Button from '@/components/atoms/Button'
import ModalHeader from '@/components/molecules/ModalHeader'
import NextArrow from 'public/images/next-arrow.svg'
import CheckIcon from 'public/images/check.svg'
import { useGetPlantTypes } from '@/services/plant-type/hooks'
import PlantTypeInterface from '@/model/interfaces/plant-type'
import { getSeedStorage } from '@/utils/index'

import ComponentStyled from './styled'

type Props = {
  onConfirm: (seed: PlantTypeInterface) => void
}

const PLANT_TYPES_PARAMS = '?populate[0]=icon&populate[1]=image&populate[2]=animation'

const SelectSeed = ({ onConfirm }: Props): JSX.Element => {
  const { t } = useTranslation()
  const { data: seeds } = useGetPlantTypes(PLANT_TYPES_PARAMS)
  const [selectedSeed, setSelectedSeed] = useState<PlantTypeInterface>()
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  const handleConfirmSeed = () => {
    if (selectedSeed) {
      onConfirm(selectedSeed)
    }
  }

  useEffect(() => {
    const selectedSeedStorage = getSeedStorage()
    if (selectedSeedStorage) {
      setSelectedSeed(selectedSeedStorage)
    }
  }, [])

  return (
    <ComponentStyled>
      <Container maxWidth='xl'>
        <div className='select-seed-box'>
          <ModalHeader prepend={t('Step 1')} title={t('Select your seed')} />
          <div className='select-seed-content'>
            {seeds?.map(seed => {
              const seedImg = seed?.attributes?.icon?.data?.attributes?.url

              return (
                <div
                  key={seed?.id}
                  className={`seed-wrapper ${selectedSeed?.id === seed.id && 'selected'}`}
                  onClick={() => setSelectedSeed(seed)}
                >
                  <div className='seed-img'>{seedImg && <Seed url={seedImg} title={seed.attributes.title} />}</div>
                  <div className='seed-content'>
                    <p className='seed-name'>{seed.attributes.title}</p>
                    <p className='seed-desc'>{seed.attributes.short_description}</p>
                  </div>
                  {selectedSeed?.id === seed.id && <CheckIcon className='check' />}
                </div>
              )
            })}
            <div className='next-btn-wrapper'>
              <Button
                fitToContainer={isMobile}
                disabled={selectedSeed ? false : true}
                size='medium'
                label={t('Next step')}
                icon={<NextArrow />}
                onClick={handleConfirmSeed}
              />
            </div>
          </div>
        </div>
      </Container>
    </ComponentStyled>
  )
}

export default SelectSeed
